export default {
  language: '言語',
  common: {
    cancel: 'キャンセル',
    fieldEmpty: 'このフィールドを空にすることはできません',
    loading: '読み込んでいます...',
    username: 'ユーザー名',
    password: 'パスワード',
    rpassword: 'パスワードを再度入力してください',
    mobile: '携帯電話番号',
    email: 'Eメール',
    login: 'ログイン',
    signup: 'サインアップ',
    back: 'バック',
    next: '次',
    submit: '参加する',
    continue: '継続する',
    close: '閉じる',
    leg: '脚',
    getFee: 'GET 費用',
    get: 'GET',
    serviceFee: 'サービス料',
    militaryClearance: '軍事クリアランス',
    endDateMust: '終了日は開始日より後である必要があります。',
    maxDurationCharter: 'チャーター予約の最大期間は {time} です。',
    invalidDateRange: '日付範囲が無効です。',
    fieldRequired: '{field} フィールドは必須です。',
    invalidEmail: '電子メール フィールドは有効な電子メールである必要があります。'
  },
  searchForm: {
    bookARide: 'チャーターサービスを予約する',
    bookACharter: '時間ごとのチャーターを予約する',
    requestARide: '今すぐ配車をリクエスト',
    bookCharter: 'チャーターサービスを予約する',
    enterPickup: '集荷場所を入力してください：',
    extraStop: 'エクストラストップ:',
    enterDropoff: 'ドロップオフの場所を入力してください：',
    whenDoYou: 'いつ配車が必要ですか?',
    untilWhen: 'いつまで必要ですか？',
    getAQuote: '見積もりを取得',
    gettingQuote: '見積もりを取得しています...',
    editCancel: 'ライドの編集/キャンセル',
    editRsvp: '予約の編集',
    trackVehicle: 'あなたの車を追跡する',
    trackRsvp: 'トラック予約',
    or: 'または',
    haveCorporate: '法人口座をお持ちですか？',
    loginSignup: 'ここからログイン/サインアップ',
    not: 'ない',
    signout: 'サインアウト',
    youAreLogged: 'あなたは個人アカウントとしてログインしています。',
    locationPlaceholder: '例えば空港、自宅など',
    startDateGreater: '開始日は、現在の時刻から {WebTimeBuffer} 分より大きくなければなりません。',
    manualPickup: '手動の集荷場所のテキスト入力は十分に正確ではありません',
    unablePinpointPickup: '希望の集荷場所を特定できません。',
    manualLocation: '手動の場所のテキスト入力は正確ではありません',
    unablePinpointExtra: 'ご希望の臨時停車地を特定できません。',
    manualDropoff: '手動ドロップオフ位置のテキスト入力は十分に正確ではありません',
    unablePinpointDropoff: '目的のドロップオフ場所を特定できません。',
    noAvailableService: '利用可能なサービスタイプがありません',
    sorryService: 'ごめんなさい！この地域では、当社のサービスはまだご利用いただけません。',
    youCanAdd: 'ストップを追加できます。',
    airports: '空港',
    themeParks: 'テーマパーク',
    ports: 'ポート',
    hotel: 'ホテル',
    universities: '大学',
    setMap: '地図上に設定',
    map: '地図',
    setLocation: '場所を設定する',
    sorry: 'ごめんなさい',
    coudntLocate: '私たちは見つけられません',
    pleaseFillForm: 'アカウントを作成するには、このフォームに記入してください',
    recommendedSize: '推奨サイズ：',
    corporateName: '会社名',
    website: 'ウェブサイト',
    billingInfo: '課金情報',
    creditCard: 'クレジットカード ＃',
    cardName: 'クレジットカード名義人氏名',
    exp: '有効期限',
    cvv: 'cvv',
    addr: '住所',
    addr1: '住所（1',
    addr2: 'アドレス2',
    city: '市',
    state: '状態',
    nonUs: '米国以外',
    zip: '郵便番号',
    country: '国',
    reviewDetails: '詳細を確認する',
    submitting: '送信します。お待ちください...',
    thankYouSignup: 'サインアップしていただきありがとうございます！',
    yourCorporate: 'あなたの会社概要は管理者による承認を待っています。アカウントが承認されると、通知が届きます。',
    ok: 'OK',
    pleaseUpload: '画像をアップロードしてください。',
    spaceNotAllowed: 'スペースは許可されていません',
    validEmail: '有効なメールアドレスを入力してください。',
    passwordNotMatch: 'パスワードと繰り返しパスワードが一致しません。',
    uploadImgFail: '画像のアップロードに失敗しました。もう一度やり直してください。',
    serviceNA: '利用できないサービス'
  },
  serviceSelect: {
    changeSelect: 'サービスオプションをもっと見る',
    future: '将来は',
    rightNow: 'たった今',
    selectAsap: 'できるだけ早くピックアップしたい場合は、このオプションを選択してください.',
    dateAsapLyft: '追加の停留所は ASAP の乗車では利用できず、自動的に削除されます。',
    pickAsap: 'できるだけ早く迎えに来てください',
    selectStartDate: '開始日を選択してください:',
    selectEndDate: '終了日を選択してください:',
    selectPickupDate: '集荷日を選択します。',
    flightArrival: 'フライト到着日',
    flightDeparture: 'フライト出発日',
    selectStartTime: '開始時間を選択してください:',
    selectEndTime: '終了時刻を選択してください:',
    selectPickupTime: 'ピックアップ時間を選択します。',
    arrivalTime: 'フライトの到着時刻を選択してください',
    departureTime: 'フライトの出発時刻を選択してください',
    mustBe: '今から少なくとも{pickuptimeRule}である必要があります',
    apply: '適用する',
    useSuggested: '推奨時間を使用する',
    timeBufferError1: '選択した時刻は、現在の時刻から{webTimeBuffer}分より大きくする必要があります。',
    timeBufferError2: 'フライト{direction}の時刻は過去に設定してはなりません',
    endDateMust: '終了日は開始日より後である必要があります。',
    chooseAirline: 'リストから航空会社を選択してください',
    chooseFlight: 'リストからフライトを選択してください',
    thisDomestic: 'これは国内線です',
    cantFindFlight: 'ここをクリックして便名を入力してください',
    typeFlight: '便名を入力します。',
    search: '探す',
    provideFlight: '便名を入力してください。',
    rideDetails: '1.ライドの詳細',
    selectService: '2.サービスを選択します',
    clickImage: '画像をクリックすると拡大表示されます',
    dontWantRT: '往復を予約したくありません。',
    rtDetails: '3.往復の詳細',
    isNotAvailable: '帰国日はご利用いただけません。 別のサービスに切り替えるか、帰りの日付を変更してみてください。',
    chooseService: '4.サービスを選択します',
    returnLater: '後で戻る？',
    bookRt: '復路を予約する',
    suggestedPickupTime: '推奨ピックアップ時間',
    firstTrip: 'あなたの最初の旅行のために',
    toMakeSurePickup: '空港に到着したらすぐに迎えに行くことができるように、お勧めのピックアップ時間は次のとおりです。',
    toMakeSureFlight: 'フライトを逃さないようにするために、推奨されるピックアップ時間は次のとおりです。',
    yesSuggested: 'はい、推奨されるピックアップ時間を使用してください。',
    noKeep: 'いいえ、ピックアップ時間を維持したいです。',
    suggestedPickupTimeReturn: '復路の推奨ピックアップ時間',
    wereSorry: '申し訳ありませんが、選択した日時の乗り物はありません。',
    legErrorFields: '区間{leg}：すべての必須フィールドに入力してください！',
    pleaseSelectService: 'サービスを選択してください。',
    legSelectService: '区間{leg}：サービスを選択してください。',
    availableOnlyFrom: 'からのみ入手可能',
    save: 'セーブ',
    bySharingRide: 'あなたの乗り物を共有することによって。',
    ifWeFind: '乗車を共有する他の人が少なくとも 1 人見つかった場合は、払い戻しを行います',
    atTheTime: 'あなたの旅行が完了した時点で。',
    iWantTo: 'ライドを誰かとシェアしたい',
    startDate: '開始日',
    endDate: '終了日',
    flightArrive: 'フライトはいつ到着しますか？',
    flightDepart: 'フライトはいつ出発しますか？',
    whenRide: 'いつ乗車が必要ですか？',
    flightInfo: 'フライト情報',
    pax: '乗客',
    choose: '選択',
    luggage: 'チェックイン荷物',
    carryOns: 'キャリーオンが含まれています',
    aptGate: 'アパート/ゲート＃',
    optional: '(オプション)',
    arrivalTimes: '提供されている到着時間は、現在の交通データに基づく推定値です。',
    forReturnTrip: '*あなたの帰りの旅行のために、あなたはに迎えに行きます',
    scheduled: '予定',
    scheduledAsap: 'スケジュール済みまたはできるだけ早く',
    selectFlightTime: '最初に飛行時間を設定してください。',
    inputFlightNo: '便名を選択または入力してください。',
    bestValue: 'お買い得',
    fastest: '最速',
    plusApplicableFees: 'プラス該当する料金',
    onewayFare: '片道運賃',
    serviceAirportAvailable1: '{service}サービスは、空港で{start}から{end}までのみ利用できます。',
    serviceAirportAvailable2: '{service}サービスは現在空港ピックアップにはご利用いただけません。',
    tryService: '<b> {service} </ b>サービスをお試しください',
    discount: 'ディスカウント:',
    minutesAway: '数分先',
    pickupDate: '受取日：',
    dropoffTime: '*落ちる： ',
    bookAdvance: '事前予約',
    mng: '会って挨拶する',
    complimentary: '無料',
    viewMoreImgs: 'もっと画像を見る',
    moreInfo: 'より詳しい情報',
    hideInfo: '情報を隠す',
    plusAppFees: 'プラス適用料金',
    oneWayFare: '片道運賃',
    downstairs: '階下',
    upstairs: '上の階',
    advantage: '利点',
    stops: '止まる',
    NA: '利用不可',
    availableFrom: 'から入手可能',
    availableUntil: 'まで利用可能',
    daysLeft: '残りの日数',
    timeLeft: '残り時間',
    tryService2: '{service}サービスをお試しください',
    wouldYouLike: '代わりに<b>{service}</ b>を試してみませんか？',
    yesChoose: 'はい、{service}を選択してください',
    pickup: '選び出す',
    extraStop: 'エクストラストップ',
    dropoff: '落ちる',
    sharedNotAllowed: 'エクストラストップで予約した場合、共有サービスは許可されていません。',
    noService: 'サービスはありません。',
    noSelectedService: '選択されたサービスはありません。',
    pickupTimeMustBe: 'ピックアップ時間は {time} 以降である必要があります。'
  },
  customerForm: {
    yourInfo: 'あなたの情報',
    emailExist: 'メールはすでにシステムに存在します。提供された電子メールに関連付けられたパスワードをお持ちの場合は、',
    clickHere: 'ここをクリック',
    toSignIn: 'サインインするには',
    otherwisePlease: 'それ以外の場合は、以前の予約で使用した電話番号を入力してください。',
    firstName: 'ファーストネーム',
    lastName: '苗字',
    iHaveWheelchair: '車いすを持っています。',
    iHaveServiceDog: '私は介助犬を飼っています。',
    previous: '前',
    serviceSelection: 'サービスの選択',
    paymentDetails: '支払詳細',
    signIn: 'ログイン',
    enterEmail: 'アカウントに関連付けられているメールアドレスを入力すると、パスワードをリセットするためのリンクがメールで送信されます。',
    sendReset: 'リセットパスワードを送信する',
    bookForSomeone: '私は乗客ではありません。私はこれを他の誰かのために予約しています。',
    paxInfo: '乗客情報',
    not: 'ない',
    signOut: 'サインアウト',
    alreadyHave: 'すでにアカウントをお持ちですか？',
    signIn2: 'ログイン',
    emailUsername: 'メールアドレスまたはユーザ名',
    forgotPass: 'パスワードをお忘れですか？',
    corporateAccnt: '企業アカウント',
    createAccnt: 'アカウントを作成して、次回これを繰り返す必要がないようにします。',
    passwordRequired: 'パスワードフィールドは必須です。',
    passwordNotMatch: 'パスワードが一致しません。',
    confirmEmail: 'Eメール確認'
  },
  driverReview: {
    thankYou: '一緒に乗ってくれてありがとう！',
    ok: 'OK',
    thankYouRating: 'この旅行を評価していただきありがとうございます！',
    feedback: 'あなたのフィードバックは、私たちがあなたにより良いサービスを提供するために改善するのに役立ちます。',
    poor: '貧しい',
    fair: 'フェア',
    average: '平均',
    good: '良い',
    execellent: '優秀な！',
    rateRide: 'ライドを評価する',
    writeComments: 'ここにあなたのコメント、褒め言葉、または提案を書いてください...'
  },
  global: {
    verify: '確認',
    verified: '確認済み',
    changePhone: '電話番号を変更する',
    textPin: '4桁のPIN番号が記載されたテキストメッセージが送信されました。下のフィールドにピンを入力してください。',
    pin: 'ピン',
    loading: '読み込み中',
    resendPin: 'ピンを再送',
    fieldRequired: 'この項目は必須です。',
    verifyFirst: '続行するには、最初にモバイルを確認する必要があります。',
    oops: 'おっと！何かがうまくいかなかった。もう一度やり直してください。',
    invalidPin: '検証ピンが無効です。',
    dropoffEstimate: '* ドロップオフ時間は、現在の交通データに基づく推定値です。'
  },
  payment: {
    payment: 'Payment',
    cardEncrypt: 'カード情報は暗号化され、安全で、保護されています。',
    selectCard: '使用するカードを選択してください',
    directBill: '直接請求',
    useNew: '新しいクレジットカードを使用する',
    selectPayment: 'お支払い方法を選択してください。',
    availablePayment: '利用可能な支払い方法',
    nameOnCard: 'カードの名前',
    isRequired: 'これは必須です。',
    cardNumber: 'カード番号',
    exp: '賞味期限',
    securityCode: 'セキュリティコード',
    for: 'ために',
    digitCard1: 'カードの<i>裏面</ i>にある3桁の数字。',
    digitCard2: 'カードの<i>前面</ i>にある4桁の数字。',
    billingAddr: '請求先住所',
    city: '市',
    state: '状態',
    chooseOne: 'いずれかを選択してください',
    zip: '郵便番号',
    country: '国',
    previous: '前',
    yourInfo: 'あなたの情報',
    validating: '検証中...',
    reviewBook: 'レビューと予約',
    followFormat: '形式に従ってください',
    invalidExp: '有効期限が無効です。',
    futureDate: '将来の日付を入力してください。',
    fare: '運賃',
    airportFee: '空港使用料:',
    fuelSurcharge: '燃油サーチャージ',
    mng: 'ミート＆グリート:',
    tip: 'ヒント',
    credits: 'クレジット:',
    redeem: '引き換え',
    total: '合計:',
    riderFee: 'ライダー料金',
    addTip: 'ヒントを追加',
    changeTip: 'ヒントを変更する',
    enterTip: 'チップを入力してください。',
    promoCode: 'プロモーションコード',
    leg: '足',
    custom: 'カスタム'
  },
  rsvpDetails: {
    hideTrip: '旅行の概要を非表示',
    showTrip: '旅行の概要を表示',
    tripSummary: '旅行の概要',
    serviceType: 'サービスの種類',
    pickupType: 'ピックアップタイプ ',
    edit: '編集',
    startDate: '開始日',
    pickupDate: '受取日',
    endDate: '終了日',
    driverNotes: 'ドライバーノート',
    aptGate: 'Apt/Gate',
    flight: 'フライト',
    curbside: 'カーブサイド',
    mng: 'ミート＆グリート',
    complimentary: '無料',
    pickup: '選び出す',
    extraStop: 'エクストラストップ',
    dropoff: '落ちる',
    inputNotes: 'ドライバーノートの入力'
  },
  review: {
    findingRide: 'あなたの乗り物を見つける',
    lookNearby: '近くのドライバーを探しています',
    busyDrivers: '私たちのドライバーは忙しいようです。で再試行',
    sendingTo: 'に送信',
    checking: '確認中',
    sending: '送信',
    yourRequest: 'あなたの要求',
    foundDriver: 'ドライバーを見つけました！',
    driverOTW: '運転手は途中です。',
    trackTrip: 'あなたの旅行を追跡する',
    close: '閉じる',
    oops: 'おっと！何かが間違っていた。後でもう一度やり直してください。',
    goBack: '戻る',
    creditCard: 'クレジットカード',
    clickPay: '[支払い]ボタンをクリックすると、',
    tos: '利用規約',
    sendEmail: 'に確認メールを送信します',
    submittingRsvp: '予約の送信',
    currentlySubmitting: '現在、ご予約を承っております。',
    dontRefresh: 'このページを離れたり、更新したりしないでください。',
    shouldntTake: 'これは長くはかからないはずです。',
    successBooked: '予約が完了しました。',
    tyRsvp: 'ご予約ありがとうございます。',
    weSentEmail: '確認メールをに送信しました',
    safelyClose: 'これで、このページを安全に閉じるか、をクリックして当社のWebサイトに戻ることができます。',
    thisLink: 'このリンク',
    unfortunately: '残念ながら、往復の支払いを処理することができませんでした。再試行して、帰りの旅行を個別に予約できます。',
    subscribed: 'メーリングリストへの登録に成功しました。',
    subscribeMailing: 'メーリングリストに登録して、限定オファーや割引を受けましょう。',
    subscribeNow: '今すぐ登録',
    reviewBook: 'レビューと予約',
    yourRsvp1: 'これが予約番号です',
    yourRsvp2: 'こちらがご予約番号です',
    pay: '支払い'
  },
  searchEdit: {
    editCancel: '予約の編集/キャンセル',
    followInfo: '続行するには、次の情報を入力してください',
    isRequired: 'これは必須です。',
    cannotFind: 'C予約が見つかりません。',
    rsvpCompleted: '予約はすでに完了しています。',
    rsvpCancelled: '予約はすでにキャンセルされています。',
    cannotEdit: 'あなたの運転手がすでにあなたを迎えに行く途中なので、あなたはあなたの予約を編集することができません。',
    onboard: 'すでに搭乗しているため、予約を編集することはできません。',
    rsvpDoesntExist: 'その予約は存在しません。提供された情報を確認して、再試行してください。',
    unassign: 'ドライバーの割り当てを解除',
    alreadyAssigned: '予約はすでにドライバーに割り当てられています。予約を編集するには、最初にドライバーから予約を解除する必要があります。',
    confirmUnassign: 'ドライバの割り当てを解除して、予約の編集を続行しますか？',
    yes: 'はい、そうです。',
    no: 'いいえ、したくありません。',
    unassigning: 'ドライバーの割り当て解除',
    rsvpNumber: '予約番号',
    firstName: 'ファーストネーム',
    lastName: '苗字'
  },
  searchTrack: {
    trackVehicle: 'あなたの車を追跡する',
    followInfo: '続行するには、次の情報を入力してください',
    isRequired: 'これは必須です。',
    rsvpCompleted: '予約はすでに完了しています。',
    rsvpCancelled: '予約はすでにキャンセルされています。',
    rsvpDoesntExist: 'その予約は存在しません。提供された情報を確認して、再試行してください。',
    rsvpNumber: '予約番号',
    firstName: 'ファーストネーム',
    lastName: '苗字'
  },
  rsvpEdit: {
    convertCredit: 'このライドをライドクレジットに変換するオプションがあります。',
    convertDesc1: 'そうすることで、あなたのアカウントはクレジットされます ',
    convertDesc2: '予約に使用できます ',
    convertDesc3: '乗車が必要なときはいつでも予約できます。',
    cxlFeeWillApply: 'キャンセル料が発生します。',
    confirmConvert: 'これをライドクレジットに変換しますか？',
    yes: 'はい、そうです。',
    no: 'いいえ、この乗車をキャンセルしたいと思います。',
    confirmCancel: 'キャンセルの確認',
    whyCancel: 'この予約をキャンセルする理由を教えてください。',
    chooseOne: 'いずれかを選択してください。',
    provideReason: 'キャンセルの理由を教えてください。',
    yesCancel: 'はい、予約をキャンセルします',
    noCancel: 'いいえ、気が変わりました。',
    cancelRsvp: '予約のキャンセル...',
    rsvp: '予約',
    creditSuccess: '正常にクレジットされました。',
    cancelSuccess: '予約をキャンセルしました。',
    ok: 'はい、わかった。',
    oops: 'おっと！何かが間違っていた。',
    tryAgain: 'あとでもう一度試してみてください。',
    reason1: '間違えて予約してしまった',
    reason2: '私は価格に満足していません',
    reason3: 'サービスに不満がある',
    reason4: '予定が変わった',
    reason5: 'ドライバーの態度が悪かった',
    reason6: '重複予約',
    reason7: 'ドライバーが集荷に遅れた',
    reason8: 'ドライバーが来なかった',
    reason9: 'ウーバーに乗りました',
    reason10: 'リフトに乗りました',
    reason11: 'タクシーに乗りました',
    reason12: 'その他',
    cancelRsvp2: '予約をキャンセルしてもよろしいですか？',
    chargeAmount: 'この予約をキャンセルすると、<b>$</b><strong>{amount}</strong>のキャンセル料が請求されます。<br/>続行しますか？',
    custInfo: '顧客情報',
    name: '名前',
    phone: '電話',
    selectStartDate: '開始日を選択してください:',
    selectEndDate: '終了日を選択してください:',
    pickupDate: '集荷日を選択します。',
    arrivalDate: 'フライトの到着日を選択してください',
    departureDate: 'フライトの出発日を選択してください',
    selectStartTime: '開始時間を選択してください:',
    selectEndTime: '終了時刻を選択してください:',
    arrivalTime: 'フライトの到着時間を選択してください',
    departureTime: 'フライトの出発時刻を選択してください',
    pickupTime: 'ピックアップ時間を選択します。',
    setEndTime: '終了時刻を設定',
    setTime: 'ピックアップ時間を設定する',
    applyTime: '時間を適用する',
    buffer1: 'ピックアップ時間は少なくとも',
    buffer2: '数分先。',
    EndDateMust: '終了日は開始日より後である必要があります。',
    maxDurationFor: 'チャーター予約の最大期間は {time} です。',
    invalidDateRange: '日付範囲が無効です。',
    driverNotes: 'ドライバーへの注意',
    saveNote: 'メモを保存',
    removeNote: 'メモを削除',
    emptyNotes: 'メモは空であってはなりません',
    chooseAirline: 'リストから航空会社を選択します。',
    chooseFlight: 'リストからフライトを選択してください',
    cantFindFlight: 'リストに自分のフライトが見つかりません。',
    fieldRequired: 'この項目は必須です。',
    domesticFlight: 'これは国内線です',
    lookingFor: '探している',
    flights: 'フライト',
    whoBooking: '誰のために予約しますか？',
    save: 'セーブ',
    bookForMyself: '私はこれを自分で予約しています。',
    nameRequired: '[名]フィールドと[名前]フィールドは必須です。',
    editingRsvp: '予約の編集',
    rsvpDetails: '予約の詳細',
    pickupLoc: 'ピックアップ場所',
    addExtraStop: '余分なストップを追加',
    extraStop: 'エクストラストップ',
    dropoffLoc: 'ドロップオフの場所',
    pickupTime2: 'お迎えの時間',
    UntilWhen: 'いつまで配車が必要ですか?',
    flightInfo: 'フライト情報',
    enterFlight: 'フライト情報を入力してください',
    pax: '乗客',
    luggage: '荷物',
    serviceType: 'サービスの種類',
    saveBySharing: '乗り物をシェアして {percent}% 節約しましょう。',
    ifWeFind: '乗車を共有する他の人が少なくとも 1 人見つかった場合は、払い戻しを行います',
    atTheTime: 'あなたの旅行が完了した時点で。',
    iWantToShare: 'ライドを誰かとシェアしたい',
    pickupType: 'ピックアップタイプ',
    mng: 'ミート＆グリート',
    complimentary: '無料',
    guestInfo: 'ゲスト情報',
    wheelchair: '車椅子',
    yes2: 'はい',
    no2: 'いいえ',
    serviceDog: '介助犬',
    driverNote: 'ドライバーノート',
    updateRsvp: '予約を更新する',
    cancelRsvp3: '予約をキャンセルする',
    returnHome: 'ホームページに戻る',
    missedSomething: '何かを逃したようです。',
    gotIt: 'はい、分かりました。',
    suggestedPickupTime: '推奨ピックアップ時間',
    suggesteDesc: '空港に到着したらすぐに迎えに行くことができるように、お勧めのピックアップ時間は次のとおりです。',
    suggesteDesc2: 'フライトを逃さないようにするために、推奨されるピックアップ時間は次のとおりです。',
    suggestedYes: 'はい、推奨されるピックアップ時間を使用してください。',
    suggestedNo: 'いいえ、ピックアップ時間を維持したいです。',
    bookingForMyself: '私はこれを自分で予約しています',
    bookingFor: 'の予約',
    addDriverNote: 'ドライバーへのメモを追加します。',
    terminal: 'ターミナル',
    provideFlightInfo: '続行するには、フライト情報を入力してください。',
    noServiceSelected: 'サービスが選択されていません。',
    serviceAccomodate1: '選択したサービスに対応できません',
    serviceAccomodate2: '乗客。<br/>続行するには、別のサービスタイプを選択してください。',
    serviceAccomodate3: '荷物。<br/>続行するには、別のサービスタイプを選択してください。',
    pickupTimeMust: '集荷時間は、少なくとも {buffer} 分先にする必要があります。',
    pleaseSetEnd: '終了日を設定してください。',
    typeLocation: '{location}の場所を入力します。',
    removeExtraStop: '余分なストップを削除',
    extraStop2: '余分な停止',
    pickup: '選び出す',
    dropoff: '落ちる',
    pickupLocation: '受け取り場所',
    dropoffLocation: '降車場所',
    sorry: 'ごめんなさい',
    couldntLocate: '私たちは見つけられません',
    paymentInfo: '支払情報',
    ccUsed: '使用したクレジットカード：',
    paidThru: '他の手段で支払われます。',
    fare: '運賃：',
    airportFee: '空港使用料：',
    fuelSurcharge: '燃油サーチャージ：',
    tip: 'ヒント：',
    creditUsed: '使用したクレジット：',
    total: '合計:',
    travelInsu: '旅行保険',
    startDate: '開始日',
    pickupDate2: '受取日',
    availableOnlyFrom: 'からのみ入手可能',
    chooseService: 'サービスを選択してください：',
    doYouWant: 'あなたのライドを他の人と共有したいですか？',
    yesIWantToShare: 'はい、他の人と乗り物を共有したいです',
    noThanks: '結構です。',
    NA: '利用不可',
    availableFrom: 'から入手可能',
    availableUntil: 'まで利用可能',
    tryOur: '私たちを試してみてください',
    service: 'サービス',
    serviceAvailable: 'サービスは空港からのみご利用いただけます',
    to: 'に',
    serviceAirportPickup: '現在、空港ピックアップのサービスはご利用いただけません。',
    wouldYouLike: 'やってみませんか',
    instead: '代わりに？',
    yes3: 'はい、選択してください',
    changePickupTime: '集荷時間を変更します',
    confirmUpdate: '更新の確認',
    updateRsvp2: '予約を更新してもよろしいですか？',
    yesUpdate: '予約を更新する',
    updatingRsvpp: '予約を更新しています...',
    successUpdate: '予約が正常に更新されました。',
    okUpdate: 'はい、わかった。',
    failUpdate: '予約を更新できません。お支払い情報を処理することはできません。',
    dueCharged: '予約に変更を加えたため、追加料金が発生します',
    yourCard: 'あなたのクレジットカードに。',
    dueRefund: '予約に変更を加えたため、返金されます',
    typeNote: 'ここにメモを入力してください',
    search: '探す...',
    typeFlight: 'フライト番号を入力します。',
    firstName: 'ファーストネーム',
    lastName: '苗字',
    phoneNumber: '電話番号',
    forRsvpInfo: '予約情報の更新については、この予約をキャンセルして、再度予約してください。',
    riderFee: 'ライダー料金'
  },
  rsvpTrack: {
    rsvpDetails: '予約の詳細',
    pickupLoc: 'ピックアップ場所',
    extraStop: 'エクストラストップ',
    dropoffLock: 'ドロップオフの場所',
    pickupTime: 'お迎えの時間',
    endTime: '終了時間',
    flightInfo: 'フライト情報',
    noFlightInfo: 'フライト情報なし',
    pax: '乗客',
    luggage: '荷物',
    serviceType: 'サービスの種類',
    pickupType: 'ピックアップタイプ',
    mng: 'ミート＆グリート',
    guestInfo: 'ゲスト情報',
    wheelchair: '車椅子',
    yes: 'はい',
    no: '番号',
    serviceDog: '介助犬',
    driverNote: 'ドライバーノート',
    bookForMyself: '私はこれを自分で予約しています',
    bookFor: 'の予約',
    noDriverNotes: 'ドライバーノートはありません。',
    terminal: 'ターミナル',
    eta: '到着予定時刻：',
    yourDriver: 'あなたのドライバー',
    noDriverYet: 'まだドライバーを持っていないようです。',
    driverCheckAgain: 'ピックアップ時間の1時間前にもう一度確認してください。',
    phone: '電話番号：',
    email: '電子メールアドレス：',
    driverLicense: '運転免許証番号：',
    bestExp: '最高のエクスペリエンスを得るには、下のボタンを使用して{brandName}モバイルアプリをダウンロードしてください。',
    appStore: 'アプリストア',
    playStore: 'プレイストア',
    trackRsvp: '予約の追跡',
    returnHome: 'ホームページに戻る'
  },
  events: {
    sentPassword: 'パスワード回復メールを送信しました',
    invalidPromo: 'プロモーションコードが無効です。',
    successRedeem: '正常に引き換えられました',
    invalidDiscount: '入力したコードは無効です。',
    expiredDiscount: '期限切れのコード: 入力したコードの有効期限が切れています。'
  },
  progressbar: {
    chooseRide: 'あなたの乗り物を選択してください',
    enterDetails: '詳細を入力してください',
    paymentDetails: '支払詳細',
    reviewBook: 'レビューと予約'
  },
  backend: {
    "There is no service available": "利用できるサービスはありません",
    "Out of coverage area": "カバレッジエリア外",
    "Trip is currently under auto-dispatch": "旅行は現在自動発送中です。",
    "Invalid token": "無効なトークン。",
    "Authentication error": "認証エラー。",
    "Corporate profile is not associated with a customer account": "企業プロファイルは顧客アカウントに関連付けられていません",
    "Authentication error. Invalid token": "認証エラー。無効なトークン。",
    "Authentication error. Account may have been logged in on another device": "認証エラー。アカウントが別のデバイスにログインしている可能性があります。",
    "Account is disabled": "アカウントが無効になっています",
    "Cannot determine pricing": "価格を決定できません",
    "This geofence does not support ASAP trips": "このジオフェンスはASAPトリップをサポートしていません",
    "Cons Auth": "短所認証",
    "Consumer account is disabled": "消費者アカウントが無効になっています",
    "Unable to use the credit card selected": "選択したクレジットカードを使用できません",
    "No payment options selected": "支払いオプションが選択されていません",
    "Please enter a valid tip": "有効なヒントを入力してください",
    "Unable to fetch pricing": "価格を取得できません",
    "This geofence does not support future reservations": "このジオフェンスは将来の予約をサポートしていません",
    "Invalid payment calculation": "無効な支払い計算",
    "Invalid pickup time": "ピックアップ時間が無効",
    "Invalid payment calculation!": "無効な支払い計算！",
    "Invalid payment calculation!!": "支払い計算が無効です!!",
    "Invalid reservation": "予約が無効です",
    "Unable to edit reservation of another brand": "他のブランドの予約を編集できません",
    "ERR_EDIT_RESTRICTED', 'Reservation cannot be edited anymore": "ERR_EDIT_RESTRICTED '、'予約はもう編集できません",
    "Cannot display brand": "ブランドを表示できません",
    "Unknown trx ID": "不明なtrxID",
    "Cant get consumer login": "消費者ログインを取得できません",
    "Cant get consumer connection": "消費者とのつながりを得ることができない",
    "Brand is required": "ブランドが必要です",
    "No phone number": "電話番号なし",
    "Error finding corporate token": "企業トークンの検索エラー",
    "Invalid corporate token": "無効な企業トークン",
    "Error finding corporate profile": "会社概要の検索エラー",
    "Corporate profile not found": "会社概要が見つかりません",
    "Error finding corporate device": "企業デバイスの検索エラー",
    "Corporate device not found": "企業デバイスが見つかりません",
    "Dispatch view requires [since]": "ディスパッチビューには[以降]が必要です",
    "Dispatch view requires [until]": "ディスパッチビューには[まで]が必要です",
    "Date range is required to filter": "フィルタリングには日付範囲が必要です",
    "Trip requires wheelchair lift": "旅行には車椅子リフトが必要です。",
    "Trip requires service dog": "旅行には介助犬が必要です。",
    "Trip requires military clearance": "旅行には軍事許可が必要です。",
    "Unable to mark as arrived, current location is not yet near the pickup": "到着済みとしてマークできません。現在の場所はまだピックアップの近くにありません",
    "ERR_RESTRICTED_GEOFENCE', 'You cannot view available reservations on a restricted area": "ERR_RESTRICTED_GEOFENCE '、'制限区域で利用可能な予約を表示することはできません",
    "Unable to mark as complete, current location is not yet near the dropoff": "完了としてマークできません。現在の場所はまだドロップオフの近くにありません",
    "cannot get staging lot queue": "ステージングロットキューを取得できません",
    "cannot find drivers": "ドライバーが見つかりません",
    "cannot find staging lots": "ステージングロットが見つかりません",
    "Cannot find driver": "ドライバーが見つかりません",
    "Cannot find driver's services": "運転免許証が見つかりません",
    "Only transport drivers are allowed at the moment": "現時点では、輸送ドライバーのみが許可されています",
    "First Name is required": "名が必要です",
    "Last Name is required": "姓が必要です",
    "Password is required": "パスワードが必要です",
    "Mobile Phone is required": "携帯電話が必要です",
    "Requires lat": "緯度が必要",
    "Requires lng": "lngが必要",
    "Requires radius": "半径が必要",
    "Package has already been accepted by a driver": "パッケージはすでにドライバーによって受け入れられています。",
    "Package is currently under auto-package": "パッケージは現在自動パッケージ化中です。",
    "Package does not contain any reservations": "パッケージには予約は含まれていません",
    "cannot find provider": "プロバイダーが見つかりません",
    "Cannot find driver's vehicle": "運転免許証が見つかりません",
    "cannot get provider's enabled services": "プロバイダーの有効なサービスを取得できません",
    "Driver cannot accept shared packages": "ドライバーは共有パッケージを受け入れることができません",
    "Vehicle is not equipped with wheelchair lift": "車両に車椅子リフトが装備されていない",
    "Vehicle cannot accommodate a service dog": "車両は介助犬を収容できません",
    "Vehicle cannot accommodate a military clearance": "車両は軍事クリアランスに対応できません",
    "Package geofence does not support TNC": "パッケージジオフェンスはTNCをサポートしていません",
    "Package geofence does not support TCP": "パッケージジオフェンスはTCPをサポートしていません",
    "Driver does not have availability at the reservation's time": "予約時にドライバーの空きがありません",
    "Trip is not available anymore": "旅行はもう利用できません。",
    "Driver cannot accept this service type": "ドライバーはこのサービスタイプを受け入れることができません",
    "gg": "日々",
    "Driver is not on duty": "運転手は当番ではありません",
    "Cannot get tracks list": "トラックリストを取得できません",
    "Cannot get geofence list": "ジオフェンスリストを取得できません",
    "Invalid reset password key": "無効なリセットパスワードキー",
    "Unable to find directions": "道順が見つかりません",
    "Unable to find directions for the specified pickup and dropoff": "指定されたピックアップとドロップオフの方向が見つかりません",
    "E_CANNOT_LOGIN": "E_CANNOT_LOGIN",
    "E_EMAIL_EXISTS": "E_EMAIL_EXISTS",
    "User not found": "ユーザーが見つかりません",
    "Parameters [contactID] must be an array": "パラメータ[contactID]は配列でなければなりません",
    "Cannot find phone numbers": "電話番号が見つかりません",
    "package items required": "必要なパッケージアイテム",
    "Part of the packages to be merged are already assigned to a driver": "マージされるパッケージの一部は、すでにドライバーに割り当てられています",
    "Part of the reservations are already assigned to a driver": "予約の一部はすでにドライバーに割り当てられています",
    "Phone number already exists": "電話番号はすでに存在します",
    "Unable to find pickup geofences": "ピックアップジオフェンスが見つかりません",
    "Unable to find dropoff geofences": "ドロップオフジオフェンスが見つかりません",
    "Services unavailable": "利用できないサービス",
    "Tip has already been given beforehand": "ヒントはすでに与えられています",
    "Consumer card not available": "消費者カードは利用できません",
    "rsvp not found": "rsvpが見つかりません",
    "No card that can be charged using stripe": "ストライプを使用して充電できるカードはありません",
    "Credit card cannot be found anymore": "クレジットカードが見つかりません",
    "rsvpId is required": "rsvpIdが必要です。",
    "Schedule not found": "スケジュールが見つかりません",
    "Schedule items not found": "スケジュール項目が見つかりません",
    "Schedule assigned to other driver": "他のドライバーに割り当てられたスケジュール",
    "Schedule is not available anymore": "スケジュールはもう利用できません",
    "Invalid fare matrix. Please contact administrator": "運賃マトリックスが無効です。管理者に連絡してください。",
    "Unable to get vehicle for provider": "プロバイダーの車両を取得できません",
    "Driver is not TNC": "ドライバーはTNCではありません",
    "requires ID": "IDが必要です",
    "1.0 Cannot updated customer profile": "1.0顧客プロファイルを更新できません",
    "1.0 Cannot create stripe profile": "1.0ストライププロファイルを作成できません",
    "Forbidden": "禁止",
    "No drivers to send": "送信するドライバーはありません",
    "Invalid password recovery token": "無効なパスワード回復トークン",
    "Cannot find admins": "管理者が見つかりません",
    "Unable to find filter": "フィルタが見つかりません",
    "Please leave a note when marking an RSVP as complete": "RSVPを完了としてマークするときは、メモを残してください",
    "Notes are required when cancelling reservation": "予約をキャンセルする際は注意が必要です",
    "Reservation not found": "予約が見つかりません",
    "Unknown charge identifier": "不明な料金識別子",
    "Invalid charge amount": "無効な請求額",
    "403 Forbidden": "403禁止します",
    "Unable to get autodispatch triggers": "自動ディスパッチトリガーを取得できません",
    "Unable to get autodispatch logs": "自動ディスパッチログを取得できません",
    "Unable to break a package that is already assigned to a driver": "すでにドライバーに割り当てられているパッケージを壊すことができません",
    "Driver not subscribed to notifications": "ドライバーが通知をサブスクライブしていません",
    "Corporate Username already exists": "企業ユーザー名はすでに存在します",
    "Unable to create profile info": "プロファイル情報を作成できません",
    "Username already exists": "ユーザー名は既に存在します",
    "Invalid corporate profile": "無効な企業プロファイル",
    "Corporate profile is not linked to a customer account": "企業プロファイルは顧客アカウントにリンクされていません",
    "Invoice not found": "請求書が見つかりません",
    "Unable to check for invoice date conflicts": "請求書の日付の競合を確認できません",
    "Failed to create invoice": "請求書の作成に失敗しました",
    "Cannot refresh invoice information": "請求書情報を更新できません",
    "Cannot find ads": "広告が見つかりません",
    "No currently running ad": "現在掲載中の広告はありません",
    "Username is required": "ユーザー名が必要です",
    "Token is required": "トークンが必要です",
    "Error trying to find corporate account": "企業アカウントを見つけようとしてエラーが発生しました",
    "Invalid corporate account": "無効な企業アカウント",
    "Corporate account is disabled": "企業アカウントが無効になっています",
    "Unable to get nearby drivers": "近くのドライバーを取得できません",
    "flight not found": "フライトが見つかりません",
    "[services] is required": "[サービス]が必要です",
    "[services] needs to be an array": "[サービス]は配列である必要があります",
    "[props] is required": "[小道具]が必要です",
    "no consumer to notify": "通知する消費者なし",
    "invalid consumer id": "無効なコンシューマーID",
    "not found": "見つかりません",
    "Unable to get credit card list": "クレジットカードリストを取得できません",
    "Catd not found": "Catdが見つかりません",
    "Action unauthorized for non-drivers": "ドライバー以外の人には許可されていない行動",
    "Your driver account is not active. Action is restricted": "ドライバーアカウントがアクティブではありません。アクションは制限されています。",
    "The reservation has already been canceled": "予約はすでにキャンセルされています",
    "Please enable your location tracking to be able to start trip": "旅行を開始できるように、位置追跡を有効にしてください",
    "Unable to get your location": "あなたの場所を取得できません。",
    "You can only start this trip once you are in the staging area": "この旅行は、ステージングエリアにいるときにのみ開始できます",
    "Reservation is not yet completed": "予約はまだ完了していません",
    "Invalid package": "無効なパッケージ",
    "Unauthorized": "許可されていない",
    "Shift not created": "シフトは作成されません",
    "Unable to find shift": "シフトが見つかりません",
    "Shift not found": "シフトが見つかりません",
    "Unable to find sector": "セクターが見つかりません",
    "Sector not found": "セクターが見つかりません",
    "Unable to find subsector": "サブセクターが見つかりません",
    "Subsector not found": "サブセクターが見つかりません",
    "Unable to find phone number for this provider": "このプロバイダーの電話番号が見つかりません",
    "Unable to find address for this provider": "このプロバイダーのアドレスが見つかりません",
    "This provider has no account yet": "このプロバイダーはまだアカウントを持っていません。",
    "Cannot find external account for this provider": "このプロバイダーの外部アカウントが見つかりません。",
    "No ongoing reservation": "継続的な予約はありません",
    "[geofenceId] needs to be passed as an array": "[geofenceId]は配列として渡す必要があります",
    "Unable to find airport association": "空港協会が見つかりません",
    "A KML File is required to activate this geofence": "このジオフェンスを有効にするには、KMLファイルが必要です",
    "Cannot find subgeofences": "サブジオフェンスが見つかりません",
    "No vehicles found for driver": "ドライバー用の車両が見つかりません",
    "1.1 Cannot update customer profile": "1.1顧客プロファイルを更新できない",
    "1.1 Cannot create stripe profile": "1.1ストライププロファイルを作成できません",
    "Unknown reservation": "予約不明",
    "Reservation is not scheduled to this time": "この時間に予約は予定されていません",
    "Forbidden to view this reservation": "この予約を表示することは禁止されています",
    "Reservation is not accepted by any provider yet": "どのプロバイダーも予約を受け付けていません",
    "There is another reservation scheduled now": "現在、別の予約が予定されています",
    "A credit card is required": "クレジットカードが必要です",
    "Unable to find list of transactions": "トランザクションのリストが見つかりません",
    "This reservation is not paid through other means": "この予約は他の方法では支払われません",
    "Card not found": "カードが見つかりません",
    "Unable to charge the card": "カードを充電できません",
    "Unable to charge the card. No result": "カードを充電できません。検索結果はありません。",
    "Unable to charge the card. No ID": "カードを充電できません。 IDなし。",
    "Notification token is required": "通知トークンが必要です",
    "Requires since parameter": "パラメータ以降が必要",
    "Requires until parameter": "パラメータまで必要です",
    "no location": "場所なし",
    "Not allowed": "禁じられている",
    "Reservation is not yet complete": "予約はまだ完了していません",
    "Reservation has already been reviewed": "予約はすでに確認済みです",
    "Sector not created": "セクターが作成されていません",
    "Subsector not created": "サブセクターが作成されていません",
    "[driverId] is required": "[driverId]が必要です",
    "Parameter [chargeFees] must be true or false only": "パラメータ[chargeFees]はtrueまたはfalseのみである必要があります",
    "Parameter [cancel] must be true or false only": "パラメータ[キャンセル]はtrueまたはfalseのみである必要があります",
    "Transaction has already been refunded": "トランザクションはすでに返金されています",
    "Unable to deduct credits": "クレジットを差し引くことができません",
    "Parameter [amount] is required": "パラメータ[金額]が必要です",
    "Unable to fetch import record": "インポートレコードをフェッチできません",
    "Unable to determine pickup geofence": "ピックアップジオフェンスを特定できません",
    "Pickup location out of coverage area": "カバレッジエリア外のピックアップ場所",
    "Unable to determine dropoff geofence": "ドロップオフジオフェンスを特定できません",
    "Dropoff location out of coverage area": "カバレッジエリア外のドロップオフ場所",
    "Attempting to { list: [], paging: {} } a non-array": "{リスト：[]、ページング：{}}非配列を試行しています",
    "Attempting to { list: [] } a non-array": "{リスト：[]}非配列を試みています",
    "Bid has already been cancelled": "入札はすでにキャンセルされています",
    "Bid has already been accepted": "入札はすでに受け付けています",
    "Unable to fetch drivers without business": "ビジネスなしでドライバーをフェッチすることはできません",
    "Unable to fetch driver list without business": "ビジネスなしでドライバーリストを取得することはできません",
    "Brand is required for quotation": "見積もりにはブランドが必要です",
    "Pickup is required for quotation": "見積もりにはピックアップが必要です",
    "Dropoff is required for quotation": "見積もりにはドロップオフが必要です",
    "No services available": "利用できるサービスはありません",
    "Unable to fetch pickup types": "ピックアップタイプをフェッチできません",
    "Unable to fetch services": "サービスを取得できません",
    "Unknown payout status": "支払い状況が不明",
    "Destination account not found 1": "宛先アカウントが見つかりません1",
    "Unknown payout status 2": "支払い状況不明2",
    "Unknown payout status 3": "支払い状況不明3",
    "Expired password recovery key": "期限切れのパスワード回復キー",
    "Charter service is not available for this area": "このエリアはチャーターサービスをご利用いただけません",
    'Invalid promo code': 'プロモーションコードが無効です。',
    'This promo code is only valid for new users': 'このプロモーション コードは新規ユーザーにのみ有効です',
    'Promo already expired': 'プロモーションはすでに期限切れです',
    "Payment method for this reservation is no longer available": "この予約の支払い方法は利用できなくなりました",
    "Phone already in use. Please log in or reset your password": "電話機はすでに使用されています。ログインするか、パスワードをリセットしてください。"
  }
}



// WEBPACK FOOTER //
// ./src/lang/jp.js